import { Nullable } from 'utils/types';

export type Resource = {
  option: string;
  value: string | boolean | number;
};

export const getResource = function<R extends Resource[]>(resources: R, value: Nullable<string>): Nullable<Resource> {
  const resource = resources.find((resource) => {
    return resource.value === value;
  });

  return resource || null;
};
